import React, { useState, useEffect } from 'react';
import Spinner from './spinner';
import './styles/registrationForm.scss'
import Cookies from 'js-cookie'

const marketoScriptId = 'mktoForms';

export default function RegistrationForm() {
    const formId = 4265;
    const [isLoaded, setIsLoaded] = useState(false);


    
    
    useEffect(() => {
        if (!document.getElementById(marketoScriptId)) {
        loadScript();
        } else {
        setIsLoaded(true);
        }
    }, []);

    useEffect(() => {
        isLoaded &&
        window.MktoForms2.loadForm(
            '//go.gridgain.com',
            '491-TWR-806',
            formId,
            (form) => {

              let mktoBtn = document.getElementsByClassName('mktoButtonRow')[0];
              let statement = document.createElement('div');
              statement.class = "ggmktoAgreement";
              statement.innerHTML = 'The information you provide will be used in accordance with the terms of our <a href="https://www.gridgain.com/privacy-policy" class="turquoise" target="_blank" rel="noreferrer noopener">privacy policy</a>.';

              mktoBtn.prepend(statement);

              /** adds the adsource to the form */
              if(Cookies.get('adsource') != null){
                const adsourceField = document.getElementsByName('adsource__c')[0];
                adsourceField.value = Cookies.get('adsource');
              }

              form.onSuccess(function(values, followUpUrl) {
                window.location.href = 'https://www.youtube.com/playlist?list=PLMc7NR20hA-KqL1RCbsK1brtDGWzbvjyL';
              });
            }
        );
    }, [isLoaded, formId]);



  const loadScript = () => {
    var s = document.createElement('script');
    s.id = marketoScriptId;
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//go.gridgain.com/js/forms2/js/forms2.min.js';
    s.onreadystatechange = function() {
      if (this.readyState === 'complete' || this.readyState === 'loaded') {
        setIsLoaded(true);
      }
    };
    s.onload = () => setIsLoaded(true);
    document.getElementsByTagName('head')[0].appendChild(s);
  };

  return (
    <div className="marketoEmbedForm" id="marketoEmbedForm">
        { isLoaded ? (
            <form id={`mktoForm_${formId}`}></form>
        ) : (
            <Spinner />
        ) }
    </div>
  );
}
